import React from 'react';
import { Flex, Box, Text, Link } from 'rebass/styled-components';
import { Logo } from '@getro/rombo';

export const NotFoundMessage = () => (
  <Flex
    sx={{
      flexDirection: 'column',
      minHeight: '100vh',
      width: '100%',
      bg: 'white',
    }}
  >
    {/* Header with Getro Logo */}
    <Flex
      sx={{
        justifyContent: 'center',
        py: '40px',
        width: '100%',
      }}
    >
      <Link
        href="https://www.getro.com"
        target="_blank"
        rel="noopener noreferrer"
        sx={{ display: 'flex', alignItems: 'center' }}
      >
        <Logo color="primary" width="96px" />
      </Link>
    </Flex>

    {/* Error Message */}
    <Flex
      sx={{
        flex: 1,
        justifyContent: 'center',
        alignItems: 'flex-start',
        pt: '120px',
        px: '24px',
      }}
    >
      <Box sx={{ maxWidth: '400px', width: '100%' }}>
        <Text
          sx={{
            fontSize: '22px',
            fontWeight: '600',
            color: 'text.dark',
            lineHeight: '1.3',
            mb: '12px',
          }}
        >
          Oops! We can&apos;t find this page
        </Text>
        <Text
          sx={{
            fontSize: '16px',
            color: 'text.main',
            lineHeight: '1.5',
          }}
        >
          Either there is an error on the URL or the form is no longer accessible. Double-check the URL or contact the
          person who shared the link with you.
        </Text>
      </Box>
    </Flex>
  </Flex>
);
